module.exports = __webpack_public_path__ + "static/img/tutor_2.fa5634e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutor_2.jpg
// module id = 2fTE
// module chunks = 1